import React, { useState, useEffect } from "react";
import ResetPassword from "./ResetPassword";
import ResetPin from "./ResetPin";
import SsPrice from "./SsPrice";
import { getGDFPrice } from "../utils/api";
import WithdrawLimit from "./WithdrawLimit";
import '../styles/styles.css';

const Main = () => {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [currentPrice, setCurrentPrice] = useState(0);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const price = await getGDFPrice();
        if (price) {
          setCurrentPrice(price);
        }
      } catch (error) {
        console.error("가격 정보를 불러오는 중 오류 발생:", error);
        setMessage("가격 정보를 불러오는 중 오류가 발생했습니다.");
      }
    };

    fetchPrice();
  }, []);

  return (
    <div className="container">
      <div className="top">
        <div className="icon-area">
          <img src="img/logo.png" alt="BI" />
        </div>
        <h1 className="title">GDFINANCE 관리자</h1>
        <p className="subtitle">&nbsp;</p>
        <div className="input-area">
          <div className="input-wrapper">
            <span className="label body-n d-gray">
              비밀번호&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
            </span>
            <input
              type="password"
              id="password"
              className="inp3 body-n"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>
      </div>
      <p>{message}</p>
      <ResetPassword
        password={password}
        setPassword={setPassword}
        setMessage={setMessage}
      />
      <ResetPin
        password={password}
        setPassword={setPassword}
        setMessage={setMessage}
      />
      <SsPrice
        password={password}
        setPassword={setPassword}
        setMessage={setMessage}
        currentPrice={currentPrice}
        setCurrentPrice={setCurrentPrice}
      />
      <WithdrawLimit
        password={password}
        setPassword={setPassword}
        setMessage={setMessage}
      />
    </div>
  );
};

export default Main;
